module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/02-6b0d47e0856dc34ef778418ebd523d9c.jpg";